export const css = {
    oneaction: 'D6oujy3Y',
    sureButtons: '_1UaASKdU',
    timerblock: '_2NknECil',
    primaryButton: '_3BEzfibF',
    ' _key': 'apic-theme/apic/micro/quiz-widgets/prometric-review'
};
export default css;
